//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { EmailInformationDisplayItem } from './EmailInformationDisplayItem';
import { TelephoneInformationDisplayItem } from './TelephoneInformationDisplayItem';
import { TagDisplayItem } from './TagDisplayItem';
import { TeacherCalendarPreferencesDisplayItem } from './TeacherCalendarPreferencesDisplayItem';
import { TeacherCalendarFeedPreferencesDisplayItem } from './TeacherCalendarFeedPreferencesDisplayItem';
import { TeacherEmailPreferencesDisplayItem } from './TeacherEmailPreferencesDisplayItem';
import { TeacherAttendancePreferencesDisplayItem } from './TeacherAttendancePreferencesDisplayItem';
import { TeacherBookingPreferencesDisplayItem } from './TeacherBookingPreferencesDisplayItem';
import { TeacherNavigationPreferencesDisplayItem } from './TeacherNavigationPreferencesDisplayItem';
import { TeacherPrivilegesAndSettingsDisplayItem } from './TeacherPrivilegesAndSettingsDisplayItem';
import { LanguageDisplayItem } from './LanguageDisplayItem';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { LoginAccessStatus, InvoiceFormat } from './Enums';

export class TeacherDisplayItem extends TeacherNameDisplayItem {
    Address: string | null = null;
    Email: EmailInformationDisplayItem | null = null;
    FormalName: string | null = null;
    FullName: string | null = null;
    HasPayrollOverrides: boolean | null = null;
    HasOnlineBookingAvailability: boolean = false;
    LastLogin: string | null = null;
    PayrollBalance: number | null = null;
    ProfilePictureURL: string | null = null;
    ProfileThumbnailURL: string | null = null;
    StudentCount: number | null = null;
    Telephone: TelephoneInformationDisplayItem | null = null;
    Title: string | null = null;
    ZoomMeetingURL: string | null = null;
    Tags: TagDisplayItem[] = [];
    Note: string | null = null;
    HasMfa: boolean = false;
    ShowSetupGuide: boolean = false;
    LastCalendarSync: string | null = null;
    AccessStatus: LoginAccessStatus = LoginAccessStatus.NoAccess;
    CalendarPreferences: TeacherCalendarPreferencesDisplayItem | null = null;
    CalendarFeedPreferences: TeacherCalendarFeedPreferencesDisplayItem | null = null;
    EmailPreferences: TeacherEmailPreferencesDisplayItem | null = null;
    AttendancePreferences: TeacherAttendancePreferencesDisplayItem | null = null;
    BookingPreferences: TeacherBookingPreferencesDisplayItem | null = null;
    NavigationPreferences: TeacherNavigationPreferencesDisplayItem | null = null;
    PrivilegesAndSettings: TeacherPrivilegesAndSettingsDisplayItem | null = null;
    InvoiceFormatPreference: InvoiceFormat = InvoiceFormat.Normal;
    TimeZoneID: string | null = null;
    SpokenLanguages: LanguageDisplayItem[] = [];
    Latitude: number | null = null;
    Longitude: number | null = null;

    constructor(initializer?: Partial<TeacherDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "TeacherDisplayItem";
}
